import { StatusContatoEnum } from '../../enum/status-contato.enum';
import { CanalOrigemContatoEnum } from '../../enum/canal-origem-contato.enum';
import { CanalModel } from '../canal/canal-model';
import {IdNome} from '../id-nome.model';
import {SessaoBuscaContato} from '../sessao/sessao-busca-contato.model';
import {UsuarioResumo} from '../usuario/usuario-resumo-model';
import { AtendimentoPessoaModel } from '../atendimento/atendimento-pessoa.model';
import { ContatoAcessoChat } from './contato-acesso-chat.model';
import { UltimaMensagemPrevia } from './ultima-mensagem-previa.model';

export class Contato {
  id!: number;
  nome?: string;
  contato!: string;
  numero!: string;
  email?: string;
  sessao?: SessaoBuscaContato;
  etapaAtual?: IdNome;
  operador?: UsuarioResumo;
  operadorAvatar?: AtendimentoPessoaModel;
  dataUltimaMensagem ?: Date
  qtdMensagensNaoLidas = 0;
  ultimaMensagemInfo?: string;
  ultimaMensagem?: string;
  ultimaMensagemPrevia?: UltimaMensagemPrevia;
  ultimaMensagemFormatada = false
  temSessaoAberta?: boolean;
  uuid?: string;
  dataFechamentoSessao?: Date;
  selecionado?: boolean = false;
  midiaId?: number;
  midiaExtensaoLogo?: string;
  clientId?: string;
  canal?: CanalModel;
  tags?: string[]
  nomeEnvioUltimaMensagem?: string;
  statusContato?: StatusContatoEnum;
  canalOrigem?: CanalOrigemContatoEnum;
  fotoPerfilUrl?: string;
  favorito?: boolean = false;
  grupoId?: number;
  acessoChat?: ContatoAcessoChat;
  tranferenciaPendenteVisu?: boolean = false;
}
